<template>
  <CCard class="contactInfo pt-4">
    <CRow>
      <CCol sm="12">
        <header class="contactInfo__header d-flex align-items-top">
          <h3 class="contactInfo__title font-weight-normal">
            Keys
          </h3>
          <CIcon name="key" class="text-gray-600 ml-2 pt-1" size="custom-size" :height="25" viewBox="0 0 32 32" />
        </header>
      </CCol>
      <CCol sm="12">
        <div class="contactInfo__body p-0">
          <!-- recipient {{recipient}} -->
          <div v-if="loading" class="w-100 h-100 d-flex justify-content-center align-items-center">
            <CSpinner class="my-3" color="primary" />
          </div>

          <CForm
            v-else
            v-show="!loading && infos"
            class="contactInfo__form form d-flex flex-column align-items-end mt-3"
            :class="{ 'form--view': !edit }"
            @submit.prevent="sendUpdateRecipient"
          >
            <div class="contactInfo__formBody form__body p-0">
              <CInput
                :label="item.value"
                addLabelClasses="text-gray-600 font-20"
                addInputClasses="text-gray-700 font-20"
                v-model="item.fieldValue"
                placeholder="Enter your name"
                :readonly="!edit"
                class="w-100 mb-0"
                v-for="(item, index) in infos"
                :key="index"
              />
            </div>

            <div class="d-flex">
              <CButton v-if="edit" type="submit" color="primary" class="py-2 px-4 mt-3 w-auto">
                Send
              </CButton>
            </div>
          </CForm>
          <!-- infos: {{infos}} -->
          <!-- infosCopy: {{infosCopy}} -->
        </div>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  name: 'ContactKeys',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      edit: false,
      infos: [],
      loading: false,
      infosCopy: [],
      recipient: [],
      messages: [],
    }
  },

  methods: {
    handleInfo() {
      const keys = Object.keys(this.recipient)
      this.infos.forEach(item => {
        if (keys.includes(item.fieldName)) {
          this.recipient[item.fieldName] = item.fieldValue
        }
      })
    },

    cancelEdit() {
      this.infos = JSON.parse(JSON.stringify(this.infosCopy))
      this.edit = false
      this.messages = []
    },

    sendUpdateRecipient() {
      this.handleInfo()
      this.messages = []
      this.loading = true

      services
        .patchRecipientId(this.$route.params.organizationId, this.$route.params.id, this.recipient)
        .then(({ data }) => {
          this.messages.push({
            status: 'success',
            text: data.message || 'infomation saved',
          })
          this.edit = false
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },

  computed: {
    contactInfoRecepient() {
      if (this.$store.state.audience.recipient && this.$store.state.audience.schemaAudience) {
        return JSON.parse(JSON.stringify(this.$store.getters['audience/contactInfoRecepient'](true)))
      }
      return []
    },

    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },
  },

  watch: {
    contactInfoRecepient(newValues) {
      this.infos = newValues
      this.infosCopy = JSON.parse(JSON.stringify(newValues))
    },
    getterRecipient(newValues) {
      this.recipient = newValues
    },
  },
}
</script>

<style lang="scss"></style>
